// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zF8s1","rootMobile":"styles_rootMobile__1PtYv"};